<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » イベント設問の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>イベント設問の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-question.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 追加ボタン
        </div>
        <div class="manual-explain">
          クリックすることで追加画面が表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した設問を削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter・属性
        </div>
        <div class="manual-explain">
          イベント設問一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象は、ID、設問、設問タイプ
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> イベント設問一覧
        </div>
        <div class="manual-explain">
          登録済みのイベント設問の一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Event Questions
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Event Questions</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-question.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add Button
        </div>
        <div class="manual-explain">
          Click to display the add screen.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Delete Button
        </div>
        <div class="manual-explain">
          Click to delete the selected questions.<br>
          The button is activated by checking the delete checkboxes in the list.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the event questions list.<br>
          *Filtering targets: ID, Questions, Question Type
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Event Questions List
        </div>
        <div class="manual-explain">
          Displays a list of registered event questions.<br>
          Click the edit icon to display the edit screen.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
